<!--
 * @Title: 标题
 * @Description: 描述
 * @Author: xulongyong
 * @Date: 2023-09-10 09:18:34
 * @LastEditors: xulongyong
 * @LastEditTime: 2023-09-10 09:18:35
 * @FilePath: \vue-privilege-routing\src\pages\business\lease-manage\index.vue
-->
<template>
    <div>
       租赁管理
    </div>
</template>

<script>
export default {
    data() {
        return {}
    }
}
</script>
